// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"4847": "5257b5b57bdc0746","73134": "2c3b0213603a9ac3","92800": "e1240bf87eab8050",}[chunkId] + ".css"
}